import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

import "./../Profile/styles.css";

// import required modules
import { FreeMode, Navigation, Thumbs } from "swiper/modules";

export default function App({logo, images}) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  return (
    <>
      <Swiper
        style={{
          "--swiper-navigation-color": "#fff",
          "--swiper-pagination-color": "#fff",
        }}
        loop={true}
        spaceBetween={10}
        navigation={true}
        autoplay={true}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper2"
      >
     {images && images.map((res)=>{
          return <>
          {res != "" ? <SwiperSlide>
          <img
            src={res}
            className="b-r-10"
          />
        </SwiperSlide> : ''}
          </>
        })}
     
      </Swiper>
      <Swiper
        onSwiper={setThumbsSwiper}
        autoplay={true}
        loop={true}
        spaceBetween={10}
        slidesPerView={4}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper"
      >
        {images && images.map((res)=>{
          return <>
          {res != "" ? <SwiperSlide>
          <img
            src={res}
            className="b-r-10"
          />
        </SwiperSlide> : ''}
          </>
        })}
      </Swiper>
    </>
  );
}
